// extracted by mini-css-extract-plugin
export default {"ctn":"TipMessage_ctn_ZDnAl","icon":"TipMessage_icon_jllLV","content":"TipMessage_content_oxP64","head":"TipMessage_head_Mfn4j"};